export { FileValidation as default };

/**
* File Import Validation Controller
*
* Handler all data from file import contacts
*
* @author      brunorbarroso <bruno-b-rodrigues@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/

class FileValidation {
  
  /**
   * Config Validation File
   *
   * @public
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  rules_allow = {
    mime_types: [
        'text/csv',
        'text/vcard',
        'text/x-vcard',
        'application/vnd.ms-excel',
    ],
    size_max: 200,
    count_contacts_max: 1000
  }

  /**
   * Validate type of file
   *
   * @param {string} mime_type
   * @returns {boolean}
   */
  validateMimeType(mime_type) {
    return this.rules_allow.mime_types.includes(mime_type);
  }

  /**
   * Validate size of file
   *
   * @param {number} size
   * @returns {boolean}
   */
  validateSize(size) {
    let sizeKb = Math.round((size / 1024))
    return sizeKb < this.rules_allow.size_max;
  }

  /**
   * Validate number of contacts
   *
   * @param {number} count_contacts
   * @returns {boolean}
   */
  validateCountContacts(count_contacts) {
    return count_contacts < this.rules_allow.count_contacts_max;
  }
}